import {
  SecureTable,
  SecureTableContainer,
  SecureTableData,
  SecureTableTbodySkeleton,
  TableSecureColumnSkeleton,
} from './TableSecure.styled';

const TableSecureSkeleton = ({ row = 3, column = 6 }) => (
  <SecureTableContainer key="skeleton-comp">
    <SecureTable>
      <SecureTableTbodySkeleton>
        {new Array(row).fill('').map(() => (
          <tr>
            {new Array(column).fill('').map(() => (
              <SecureTableData>
                <TableSecureColumnSkeleton active />
              </SecureTableData>
            ))}
          </tr>
        ))}
      </SecureTableTbodySkeleton>
    </SecureTable>
  </SecureTableContainer>
);

export default TableSecureSkeleton;
